import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../cart/CartContext';

export default function CartAddedToast() {
  const { toast, dismissToast, itemCount } = useCart();

  useEffect(() => {
    if (!toast) return undefined;
    const t = window.setTimeout(() => dismissToast(), 4500);
    return () => window.clearTimeout(t);
  }, [toast, dismissToast]);

  if (!toast) return null;

  return (
    <div className="cart-added-toast" role="status" aria-live="polite">
      <div className="cart-added-toast__inner">
        <span className="cart-added-toast__check" aria-hidden>
          ✓
        </span>
        <div className="cart-added-toast__text">
          <strong className="cart-added-toast__title">Added to cart</strong>
          <span className="cart-added-toast__product">{toast.productName}</span>
        </div>
        <Link to="/cart" className="btn btn-sm btn-primary rounded-pill cart-added-toast__cta">
          View cart ({itemCount})
        </Link>
        <button
          type="button"
          className="btn-close cart-added-toast__close"
          aria-label="Dismiss"
          onClick={dismissToast}
        />
      </div>
    </div>
  );
}
